import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RequestComponent } from '../requests/request/request.component';
import { TaskComponent } from '../tasks/task/task.component';
import { DialogService } from './services/dialog.service';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit, OnDestroy {  
  requestId: number | undefined;
  dialogBoxSubscription?: Subscription;
  dialogComponentSubscription?: Subscription;
  componentToLoad?: string;
  
  
  constructor(public dialog: MatDialog, private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly dialogService: DialogService) {
    this.requestId = this.route.snapshot.params['id'];     
  }
   
  ngOnInit(): void {
    this.dialogComponentSubscription = this.dialogService.componentEmitter.subscribe({
      next: (loadingComponent) => this.componentToLoad = loadingComponent
    });    
    this.openDialog();  
  }

  openDialog(): void {    
    if (this.componentToLoad === "Request") {
     const requestDialogRef = this.dialog.open(RequestComponent, {
        data: { id: this.requestId },
        width: '100%'
     });
      this.dialogBoxSubscription = requestDialogRef.afterClosed().subscribe({
        next: (result: any) => {
          this.router.navigate(['../'], { relativeTo: this.route });
        }
      });
    }   
    
    else if (this.componentToLoad === "Task") {
      const taskDialogRef = this.dialog.open(TaskComponent, {
        data: { id: this.requestId },
        width: '100%'
      });
      this.dialogBoxSubscription = taskDialogRef.afterClosed().subscribe({
        next: (result: any) => {
          this.router.navigate(['../'], { relativeTo: this.route });
        }
      });
    }
    
  }
  ngOnDestroy(): void {
    this.dialogBoxSubscription?.unsubscribe();
    this.dialogComponentSubscription?.unsubscribe();
  }
}
